import { Button, Drawer, message, Space } from 'antd'
import React, { useEffect, useRef } from 'react'
import { useStyle } from './style'

import { useConversationContext } from '../../../stores/conversation.store'
import { functionMenuItems } from './const'
import {
  useFunctionMenuStore,
  MenuPage,
} from '../../../stores/functionMenu.store'
import { useNavigate } from 'react-router-dom'
import type { FunctionMenuItem } from '../../../types'
import { Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import './style.css'
import logo from '@/assets/images/logo／img.png'
import logoTex from '@/assets/images/Hi.AI.png'
import sidebar from '@/assets/icon/AI／icon／sidebar.png'
import sidebar2 from '@/assets/icon/AI／icon／sidebar-2.png'
import delBtn from '@/assets/icon/AI／icon／delet.svg'

const { confirm } = Modal
export interface ConversationItem {
  key: string
  label: React.ReactNode
}

const FunctionMenu = () => {
  const { styles } = useStyle()
  const { menuCollapsed, toggleMenuCollapsed, chooseActiveMenuPage } =
    useFunctionMenuStore()
  const {
    conversations,
    activeConversation,
    chooseActiveConversation,
    deleteConversation,
    clearActiveConversation,
    createConversation,
  } = useConversationContext()

  const navigate = useNavigate()

  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 1080)
  const lastIsMobile = useRef(isMobile)
  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth <= 1080

      // 只有当状态从 "非移动端" 变为 "移动端" 时，才触发折叠
      // 这样窗口变大（isMobile 变成 false）或者已经在移动端范围内缩放时，都不会触发逻辑
      if (isMobile && !lastIsMobile.current && !menuCollapsed) {
        toggleMenuCollapsed()
      }

      // 更新上一次的状态记录
      lastIsMobile.current = isMobile
      setIsMobile(isMobile)
    }
    // 注意：这里去掉了初始化直接执行 handleResize()，
    // 或者是仅在初始化时更新 ref 而不调用 toggle
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [toggleMenuCollapsed, menuCollapsed])

  const onAddConversation = (item: FunctionMenuItem) => {
    const newConversation = createConversation(item.key as MenuPage, [])
    if (newConversation) {
      chooseActiveConversation(newConversation.conversationId)
      navigate(`/${item.key}/${newConversation.conversationId}`)
    }
  }

  const onConversationClick = (conversationId: string) => {
    try {
      const conversation = conversations.find(
        (conv) => conv.conversationId === conversationId
      )

      if (conversation) {
        // 先清除activeConversation，强制触发重新渲染
        if (activeConversation?.conversationId !== conversationId) {
          clearActiveConversation()
        }

        chooseActiveMenuPage(conversation.type)
        chooseActiveConversation(conversationId)
        navigate(`/${conversation.type}/${conversationId}`)
      }
    } catch (error) {
      console.error('处理会话点击出错:', error)
    }
  }

  const handleNewChat = () => {
    navigate('/chat')
  }
  const renderMenuContent = () => {
    return (
      <>
        {' '}
        {/* 🌟 顶部信息 */}
        <div
          className={styles.userProfile}
          style={menuCollapsed ? {} : { justifyContent: 'flex-start' }}
        >
          <Space align="center">
            <img src={logo} alt="logo" style={{ height: 42 }} />
            {!menuCollapsed && (
              <img src={logoTex} alt="logoText" style={{ height: 16 }} />
            )}
          </Space>

          {!menuCollapsed && (
            <Button
              type="text"
              icon={
                <img src={sidebar} alt="menuCollapsed" style={{ height: 18 }} />
              }
              onClick={toggleMenuCollapsed}
            />
          )}
        </div>
        {/* 🌟 功能菜单 */}
        <div className={styles.functionMenu}>
          {functionMenuItems.map((item) => {
            return (
              item.render?.({
                item,
                onAddConversation,
                chooseActiveMenuPage: () => {
                  clearActiveConversation()
                  navigate(`/${item.key}`)
                },
                styles,
                handleNewChat,
              }) || (
                <div
                  key={item.key}
                  className={styles.functionMenuItem}
                  onClick={() => {
                    clearActiveConversation()
                    navigate(`/${item.key}`)
                  }}
                >
                  {item.icon}
                  {!menuCollapsed && (
                    <span style={{ marginLeft: 16 }}>{item.label}</span>
                  )}
                </div>
              )
            )
          })}
        </div>
        {menuCollapsed && (
          <Button
            type="text"
            icon={
              <img src={sidebar2} alt="menuCollapsed" style={{ height: 18 }} />
            }
            className={styles.collapsedMenuBtn}
            onClick={toggleMenuCollapsed}
          />
        )}
        {!menuCollapsed && (
          <>
            <span className={styles.conversationHistory}>历史记录</span>
            <div className={styles.conversationsContainer}>
              <div className={styles.conversationsScrollContainer}>
                {conversations.map((conversation) => (
                  <ConversationItem
                    conversation={conversation}
                    key={conversation.conversationId}
                  />
                ))}
              </div>
            </div>
          </>
        )}
      </>
    )
  }
  interface ConversationItemProps {
    conversation: any
  }
  const ConversationItem: React.FC<ConversationItemProps> = ({
    conversation,
  }) => {
    const isActive =
      activeConversation?.conversationId === conversation.conversationId
    return (
      <div
        key={conversation.conversationId}
        className={`conversationItem ${isActive ? 'active' : ''}`}
        onClick={() => onConversationClick(conversation.conversationId)}
      >
        <span className={styles.conversationTitle}>{conversation.title}</span>
        <div
          className={`actionButtonsContainer`}
          onClick={(e) => e.stopPropagation()}
        >
          <Button
            type="text"
            className={styles.deleteButton}
            icon={
              <img
                src={delBtn}
                alt="deleteButton"
                style={{ height: 18, marginTop: 3 }}
              />
            }
            onClick={(e) => {
              e.stopPropagation()

              confirm({
                title: '确认删除该会话吗？',
                icon: <ExclamationCircleOutlined />,
                content: '删除后将无法恢复',
                okText: '确认',
                cancelText: '取消',
                onOk: () => {
                  if (conversations.length <= 1) {
                    message.info('至少需要保留一个会话')
                    return
                  }

                  if (
                    activeConversation?.conversationId ===
                    conversation.conversationId
                  ) {
                    navigate(`/${activeConversation.type}`)
                    setTimeout(
                      () => deleteConversation(conversation.conversationId),
                      100
                    )
                  } else {
                    deleteConversation(conversation.conversationId)
                  }
                  message.success('删除成功！')
                },
                onCancel: () => { },
              })
            }}
          />
        </div>
      </div>
    )
  }
  if (isMobile) {
    return (
      <>
        <Drawer
          placement="left"
          onClose={toggleMenuCollapsed}
          open={!menuCollapsed} // 借用原来的折叠状态控制显隐
          width={280}
          styles={{ body: { padding: 16 } }}
          closable={false}
        >
          {renderMenuContent()}
        </Drawer>
      </>
    )
  }
  return (
    <>
      <div className={`${menuCollapsed ? styles.menuCollapsed : styles.menu}`}>
        {renderMenuContent()}
      </div>
    </>
  )
}

export default FunctionMenu
